// Recently Viewed Products — localStorage backed
// Stores up to 12 products as {id, slug, name, image, price, mrp}
const KEY = "nc_recently_viewed";
const MAX = 12;

export function getRecentlyViewed() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function addRecentlyViewed(product) {
  if (!product || !product.id) return;
  const minimal = {
    id: product.id,
    slug: product.slug,
    name: product.name,
    image: (product.images && product.images[0]) || product.image || "",
    price: product.price,
    mrp: product.mrp || null,
  };
  const current = getRecentlyViewed().filter((p) => p.id !== minimal.id);
  const next = [minimal, ...current].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
    // Notify listeners in same tab
    window.dispatchEvent(new Event("nc:recently-viewed-updated"));
  } catch {
    // Quota exceeded — silently ignore
  }
}

export function clearRecentlyViewed() {
  try {
    localStorage.removeItem(KEY);
    window.dispatchEvent(new Event("nc:recently-viewed-updated"));
  } catch { /* noop */ }
}
